const productsFiles = [
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220002",
        id: "1",
        title: "HY2400",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/InstallationAndRequirements1.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/UseAndMaintenance1.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220003",
        id: "2",
        title: "HY3000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance2.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/InstallationAndRequirements2.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220004",
        id: "3",
        title: "HY4000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance3.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/InstallationAndRequirements3.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220005",
        id: "4",
        title: "HY5000-6000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance4.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/InstallationAndRequirements4.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220006",
        id: "5",
        title: "HY8000-10000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance5.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/InstallationAndRequirements5.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220007",
        id: "6",
        title: "HY13000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance6.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/InstallationAndRequirements6.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220008",
        id: "7",
        title: "HY15000-28000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance7.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/InstallationAndRequirements7.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220009",
        id: "8",
        title: "HY34000-45000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance8.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/InstallationAndRequirements8.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220010",
        id: "9",
        title: "HYTC 600",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance9.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy2.pdf",
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220011",
        id: "10",
        title: "SM Series",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/SMSeriesOperationAndMaintenanceManual.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy2.pdf",
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220012",
        id: "11",
        title: "SM100 Series",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/SM100SeriesOperationAndMaintenanceManual.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy2.pdf",
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220013",
        id: "12",
        title: "SME Series",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/SMESeriesOperationAndMaintenanceManual.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy2.pdf",
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "13",
        title: "TM Series",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/TMSeriesOperationAndMaintenanceManual.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy2.pdf",
    },
];

export function getProductFilesById(id) {
    return productsFiles.filter(m => m.id === id);
}